import { Suspense } from 'react';
import { Route, Routes } from 'react-router-dom';
import LoaderText from '../components/loader/LoaderText';
import Error404 from '../pages/error/Error404';
import BlankLayout from '../layout/BlankLayout';

const GuestRoute = () => {
    return (
        <Suspense fallback={<BlankLayout><LoaderText /></BlankLayout>}>
            <Routes>
                <Route path='*' element={<Error404 />}></Route>
            </Routes>
        </Suspense>
    )
}

export default GuestRoute;